// extracted by mini-css-extract-plugin
module.exports = {"roundButton":"_3C-ml","isActive":"_3-RNa","circle":"_1l_-W","disabled":"_J3iF","medium":"jRczx","small":"_3nujk","red":"_38LEj","bgIcon":"_1BtJD","denied":"IuarL"};